<template><div>
  <h1 class="fdd-md--h1">Layout Grid</h1>
<h2 class="fdd-md--h2">Playground</h2>
<d-example name="playground">
</d-example>
<h2 class="fdd-md--h2">2-col product tile grid</h2>
<!-- ## 2-col grid
<d-example name="tile-grid--col-2-with-tile">
</d-example>

## 3-col grid (default)
<d-example name="tile-grid--col-3-with-tile">
</d-example>

## 4-col grid
<d-example name="tile-grid--col-4-with-tile">
</d-example>

## 5-col grid
<d-example name="tile-grid--col-5-with-tile">
</d-example>

## 6-col grid
<d-example name="tile-grid--col-6-with-tile">
</d-example>

## 6-col grid with span helpers
<d-example name="tile-grid--span-helpers">
</d-example> -->

  </div></template>
  <script>
  export default {
    $frontmatter: {fdRelatedComponents:["fd-layout-grid"]},
    beforeCreate() {
      this.$frontmatter = {fdRelatedComponents:["fd-layout-grid"]}
    }
  }
  </script>
  